export const hasHtmlBlock = (markdown: string): boolean => /^\s*```html[ \t]*$/im.test(markdown)
